import universityModule from './universityModule';

export default {
    template: [
        'SCHOOL_TEMPLATE',
        data => ({
            id: data.id,
            name: data.name,
            logo: data.logo,
            verified: data.verified,
        }),
    ],
    GET: {},
    POST: {},
};
